import { useQuery } from "react-query";
import axios from "infra/http";
import { PaginateResult } from "core/resources/types/shared";
import { PessoaItem } from "../typings";
import { useCurrentTenant } from 'core/features/auth/tenant.store';

function usePessoasAutocomplete(search?: string) {
  const {tenant} = useCurrentTenant();
  return useQuery([`/v1/pessoas?tenant=${search}`, tenant.id], async () => {

    const { data } = await axios.get<PaginateResult<PessoaItem>>(
      `/v1/pessoas`,
      {
        params: {
          tenantId: tenant.id,
          search,
        },
      }
    );

    return data;
  });
}

export default usePessoasAutocomplete;
